import { useContext, useEffect, useState } from "react";
import { Box, Typography, Button, Stack, LinearProgress, Divider } from "@mui/material"
import { ComputeDays, ComputePercentage, GetPercentageFormat, StartUpperCase } from "../../global/Format";
import { GetToolUsagePercentage } from "../../../global/API";
import { FeatureState } from "../../global/GlobalFcn";
import { ToolContext } from "../../../../core/context/ToolContext";
import { UsageAwarenessLoader } from "../../loader/Loader";
import { DetailsModal } from "./DetailsModal";
import { UserSummary } from "../userSummary/UserSummary";
import moment from "moment";

export const UsagePercentage = ({__SESSION, graphDatasets, interval}) => {

    const { usage_state } = useContext(ToolContext)
    const { toolUsageData } = usage_state

    const [open, setOpen] = useState(false)
    const [usageAwareness, setUsageAwareness] = useState({
        average:0,
        data:[],
        loader:false
    })
    
    // SAMPLE DATA RESULT
    // const res_data_count = [
    //     {feature_id:1, feature_name:"dashboard", path:"1", count:1},
    //     {feature_id:2, feature_name:"bcloud", path:"2", count:1},
    //     {feature_id:3, feature_name:"policies", path:"3", count:30},
    //     {feature_id:4, feature_name:"general-maintenance", path:"4", count:40},
    //     {feature_id:5, feature_name:"hero", path:"5", count:50},
    //     {feature_id:6, feature_name:"tool-categories", path:"6", count:52},
    //     {feature_id:7, feature_name:"profile", path:"7", count:70},
    // ]
    // const res_target = [
    //     {feature_id:1, feature_name:"dashboard", path:"1", value:10},
    //     {feature_id:2, feature_name:"bcloud", path:"2", value:20},
    //     {feature_id:3, feature_name:"policies", path:"3", value:30},
    //     {feature_id:4, feature_name:"general-maintenance", path:"4", value:40},
    //     {feature_id:5, feature_name:"hero", path:"5", value:50},
    //     {feature_id:6, feature_name:"tool-categories", path:"6", value:60},
    //     {feature_id:7, feature_name:"profile", path:"7", value:70},
    // ]

    
    const getUsageAwareness = async() => {

        const res_target = toolUsageData.data.feature_data.filter(f => {return f.usage_threshold > 0})
        
        if (res_target) {
            setUsageAwareness((prev) => ({...prev, 
                loader:true
            }))
            
            if (graphDatasets.data.dates.length > 0){
                let role_type = graphDatasets.data.assigned_id === 0 ? __SESSION.data.uaccess[0]?.role_name : graphDatasets.data.role_name
                let ftrdata = await FeatureState('all', role_type) || console.log('Feature Name is Not Found!')
                if (ftrdata) {
                    let res_ftlr_data = ftrdata?.map(v => {return {feature_id:v.id, feature_name:v.feature_name, path:v.path } })
                    let res_compute_days = await ComputeDays(graphDatasets.data.start_date, graphDatasets.data.last_date)
                    
                    const combineArray = res_target?.map((rt) => {
                        const rfd = res_ftlr_data.find((rfd) => rfd.feature_id === rt.feature_id && rfd.feature_name === rt.feature_name); 
                        return {...rfd, value:rt?.usage_threshold * res_compute_days || 0};
                    });
                    
                    
                    let qsp = {
                        company_id:__SESSION.data.uaccess[0]?.company_id,
                        tool_id:parseInt(process.env.REACT_APP_TID),
                        user_id:graphDatasets.data.assigned_id === 0 ? parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]) : graphDatasets.data.assigned_id,
                        date_from:graphDatasets.data?.start_date,
                        date_to:graphDatasets.data?.last_date,
                    }
                    
                    let res_data = await GetToolUsagePercentage(qsp)
                    
                    const finalArray = combineArray?.map((ca) => {
                        const rdc = res_data?.find((rdc) => ca.feature_id === rdc.feature_id && ca.path === rdc.path); 
                        return {...ca, usage:rdc? ComputePercentage(rdc.count, ca.value) : 0};
                    });
                    const averageUsage = finalArray?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / finalArray?.length
                    setUsageAwareness((prev) => ({...prev, 
                        data:finalArray || [], 
                        average:GetPercentageFormat(averageUsage) || 0,
                        loader:false
                    }))
                }
            }
        }
    }

    useEffect(() => {
        getUsageAwareness()
        // eslint-disable-next-line
    }, [graphDatasets.data.dates, toolUsageData.data.active_threshold])

    return (
        <Box width="100%" height="530px" bgcolor="#FFFFFF" borderRadius="16px" p="24px" border="1px solid #D6D9DB" >
            <Stack height="100%" gap="23px">
                <Stack minHeight="52px" direction="row" justifyContent="space-between" alignItems="center">
                    <Stack gap={1.5}>
                        <Stack direction="row" gap={1.5}>
                            <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%">Usage Percentage</Typography>
                            <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5DB55D">Info</Typography>
                        </Stack>
                        <Typography fontWeight={400} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5B6167">
                            {StartUpperCase(interval)} - {moment(graphDatasets.data.start_date).format('MMM DD')} - {moment(graphDatasets.data.last_date).format('DD, YYYY')}
                        </Typography>
                    </Stack>
                    <Stack alignItems="flex-end" gap="4px">
                        <Button 
                            disabled={interval !== 'daily'}
                            onClick={()=>{setOpen(true)}}
                            sx={{
                                width:'123px',
                                height:'52px',
                                bgcolor: "#F7F8F8",
                                borderRadius:'6px',
                                "&:hover": {
                                    backgroundColor: "#F7F8F8", 
                                    boxShadow: "none",
                                }}}
                        >
                            <Typography fontWeight={600} fontSize={14} lineHeight="147%" letterSpacing="0%" color="#003022">See details</Typography>
                        </Button>
                        {interval !== 'daily' && (
                            <Typography fontWeight={400} fontSize={11} lineHeight="120%" letterSpacing="-0.75%" color="red">
                                Only the daily interval is currently supported.
                            </Typography>
                        )}
                    </Stack>
                </Stack>
                <UserSummary graphDatasets={graphDatasets} __SESSION={__SESSION} percentage={usageAwareness.average} loader={usageAwareness.loader}/>
                <Divider/>
                <Stack height="100%" className="overflowY" gap={1.5} pr="44px">
                    {usageAwareness.loader ? 
                        <UsageAwarenessLoader/>
                    :
                        usageAwareness.data?.map((ua, index)=>(
                            <Stack key={index} gap={1}>
                                <Stack minHeight="24px" direction="row" justifyContent="space-between" alignItems="center">
                                    <Typography fontWeight={400} fontSize={14} lineHeight="147%" letterSpacing="0%" color="#5B6167">{StartUpperCase(ua.feature_name)}</Typography>
                                    <Typography fontWeight={500} fontSize={12} lineHeight="14px" letterSpacing="0%" color="#5DB55D">{ua.usage}%</Typography>
                                </Stack>
                                <LinearProgress variant="determinate" value={ua.usage} 
                                    sx={{height: 16, borderRadius: 4, bgcolor: "#FBFCFB",'& .MuiLinearProgress-bar': {backgroundColor: '#5DB55D', borderRadius: 2},}} 
                                />
                            </Stack>
                        ))
                    }
                </Stack>
            </Stack>
            {!usageAwareness.loader && 
                <DetailsModal open={open} setOpen={setOpen} graphDatasets={graphDatasets} __SESSION={__SESSION}/>
            }
        </Box>
    )
}